import { LeafMultimediaLimelight } from "./multimedia-limelight.component.js";
import "lit";
import "lit/decorators.js";
import "lit/directives/class-map.js";
import "../leaf-element.js";
import "../../utilities/events.js";
import "../../utilities/loaders.js";
import "../../utilities/light-dom-styles.js";
customElements.define("leaf-multimedia-limelight", LeafMultimediaLimelight);
export {
  LeafMultimediaLimelight
};
//# sourceMappingURL=multimedia-limelight.js.map
